
define('text!views/modals/alerts/GameMessagesAlert.html',[],function () { return '<div class="modal jurisdiction-alert">\n    <div class="modal-content flex-vertical fj-center center color-white" data-bind="foreach: messages">\n        <h2 class="gutter-bottom">{{{$data}}}</h2>\n    </div>\n</div>';});

